import axios from "axios";
import React, { useEffect, useState } from "react";
import { base_url } from "../../utils/AxiosConfig";
import { LuPanelLeftOpen, LuPanelRightOpen } from "react-icons/lu";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { FaFileInvoiceDollar } from "react-icons/fa6";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import SnackbarNotification from "../../utils/SnackbarNotification";
import dayjs from "dayjs";

const MainPayroll = () => {
  const [payrollData, setPayrollData] = useState([]);
  const [paySlipData, setPaySlipData] = useState(null);
  const [Open, setOpen] = useState(false);
  const [showPayslip, setShowPayslip] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [payslipStartDate, setPayslipStartDate] = useState(
    dayjs().startOf("month").format("YYYY-MMM-DD"),
  );
  const [payslipEndDate, setPayslipEndDate] = useState(
    dayjs().format("YYYY-MMM-DD"),
  );
  const [branchListFromAPI, setBranchListFromAPI] = useState([]);
  const [branch, setBranch] = useState("-");
  const [deptListFromAPI, setDeptListFromAPI] = useState([]);
  const [dept, setDept] = useState("-");
  const [gradeListFromAPI, setGradeListFromAPI] = useState([]);
  const [grade, setGrade] = useState("-");

  useEffect(() => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }
    fetchPayrollData(companyCode);
    getBranchList(companyCode);
    getDeptList(companyCode);
    getGradeList(companyCode);
  }, []);

  const getBranchList = async () => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }

    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/DEPARTMENT/-`,
      // `${base_url}/api/MASTERLIST/CUBIX/DEPARTMENT/-`
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setBranchListFromAPI(newArray.map((i) => i.Description));
    } else {
      console.log("error");
    }
  };

  const getDeptList = async () => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }

    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/DEPT/-`,
      // `${base_url}/api/MASTERLIST/CUBIX/DEPT/-`
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      console.log("dept newArray", newArray);
      setDeptListFromAPI(newArray.map((i) => i.Description));
    } else {
      console.log("error");
    }
  };

  const getGradeList = async (companyCode) => {
    const response = await axios.get(
      // `${base_url}/api/MASTERLIST/CUBIX/GRADE/-`
      `${base_url}/api/MASTERLIST/${companyCode}/GRADE/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      // console.log('newArrayList',newArray.map((i)=>i.Description))
      // console.log('newArray',newArray)
      setGradeListFromAPI(newArray.map((i) => i.Description));
      // setGrade(newArray);
    } else {
      console.log("error");
    }
  };

  const fetchPayrollData = async (companyCode) => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCodeFromAPI = null;

    if (storedUserDataArray) {
      companyCodeFromAPI = storedUserDataArray[0].cmpcode;
    }
    try {
      const response = await axios.get(
        // `${base_url}/api/Payroll/CUBIX/${payslipStartDate}/${payslipEndDate}/${branch}/${dept}/${grade}`
        `${base_url}/api/Payroll/${companyCodeFromAPI}/${payslipStartDate}/${payslipEndDate}/${branch}/${dept}/${grade}`,
      );
      const data = response.data;
      console.log("data main paryoll", data);
      setPayrollData(data);
    } catch (err) {
      console.error(err, "error");
    }
  };

  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "success",
    message: "",
  });

  const showSnackbar = (severity, message) => {
    setSnackbar({ open: true, severity, message });
  };

  const handleClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const callPaySlipAPI = async (empID) => {
    console.log("payslip empId", empID);
    setIsLoading(true);
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }

    try {
      const response = await axios.get(
        `${base_url}/api/Payslip/${companyCode}/${payslipStartDate}/${payslipEndDate}/${empID}`,
        // `${base_url}/api/Payslip/CUBIX/${payslipStartDate}/${payslipEndDate}/${empID}`
      );

      if (response.status === 200) {
        showSnackbar("success", "Payslip generated successfully");
      } else {
        showSnackbar("error", "Failed to generate payslip.");
      }
    } catch (error) {
      showSnackbar("error", "An error occurred while payslip.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className="flex justify-between items-end mb-4 ">
        {/* <h6 className="text-2xl mb-2 font-bold text-gray-600 flex  justify-start items-center">
          Payroll
        </h6> */}

        <div className="flex justify-left items-center">
          <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full  mr-2"></div>
          <h6 className="text-xl font-bold text-gray-900 flex items-center gap-4">
            {/* <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-[#2663EB] to-blue-700 text-white shadow-lg">
      <MdPersonAddAlt className="w-7 h-7" />
      </span> */}
            <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
              PAYROLL
            </span>
          </h6>
        </div>

        <div className="flex justify-center items-end gap-4 ">
          {/* Branch Select */}
          <FormControl variant="outlined" sx={{ minWidth: 180 }} size="small">
            <InputLabel id="branch-select-label">Branch</InputLabel>
            <Select
              labelId="branch-select-label"
              value={branch}
              // onChange={(e) => handleChange(e, "division")}
              label="Branch"
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {branchListFromAPI?.map((b) => (
                <MenuItem
                  key={b.DEPTNO}
                  value={b}
                  onClick={() => {
                    //   setSelectedDivision(b.deptnodesc);
                    setBranch(b);
                  }}
                >
                  {b}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl variant="outlined" sx={{ minWidth: 180 }} size="small">
            <InputLabel id="department-select-label">Department</InputLabel>
            <Select
              labelId="department-select-label"
              value={dept}
              // onChange={(e) => handleChange(e, "department")}
              label="Department"
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {deptListFromAPI?.map((dept) => (
                <MenuItem
                  // key={dept.id}
                  value={dept}
                  onClick={() => {
                    setDept(dept);
                    //   setSelectedDepartmentCode(dept.code);
                  }}
                >
                  {dept}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl variant="outlined" sx={{ minWidth: 180 }} size="small">
            <InputLabel id="grade-select-label">Grade</InputLabel>
            <Select
              labelId="grade-select-label"
              value={grade}
              // onChange={(e) => handleChange(e, "grade")}
              label="Grade"
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {gradeListFromAPI?.map((g) => (
                <MenuItem
                  // key={g.TranId}
                  value={g}
                  onClick={() => {
                    setGrade(g);
                  }}
                >
                  {g}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <div className="d-flex">
            <div>
              <label
                htmlFor="exampleInputEmail1"
                className="form-label fs-small text-secondary"
              >
                Start Date
              </label>
              <input
                type="date"
                className="form-control"
                id="startDate"
                name="startDate"
                value={payslipStartDate}
                onChange={(e) => setPayslipStartDate(e.target.value)}
                max={new Date().toISOString().split("T")[0]}
              />
            </div>

            <div className="ms-2">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label fs-small text-secondary"
              >
                End Date
              </label>
              <input
                type="date"
                className="form-control"
                id="endDate"
                name="endDate"
                value={payslipEndDate}
                onChange={(e) => setPayslipEndDate(e.target.value)}
                max={new Date().toISOString().split("T")[0]}
              />
            </div>
          </div>

          <button
            // onClick={() => callGeneratePayrollAPI()}
            onClick={() => fetchPayrollData()}
            className="btn btn-sm"
            style={{ backgroundColor: "#1DAAF7", color: "#ffffff" }}
          >
            Generate Payroll
          </button>

          <div className="mb-2">
            {Open === true ? (
              <>
                <LuPanelRightOpen onClick={() => setOpen(false)} />
              </>
            ) : null}
            {Open === false ? (
              <>
                <LuPanelLeftOpen onClick={() => setOpen(true)} />
              </>
            ) : null}
          </div>
        </div>
      </div>
      <div className="overflow-auto max-w-85 scrollbar-none rounded-md">
        {payrollData ? (
          <>
            {/* <table className="table-auto w-full bg-white text-xs border-collapse border border-gray-300 shadow-sm rounded-md px-6 overflox-x-auto"> */}
            <table className="shadow-sm min-w-full  rounded-sm border border-[gray-300] text-xs ">
              <thead>
                <tr className="bg-[#2663EB] text-white">
                  <th className="px-1.5 py-1  font-normal">
                    Sl No
                  </th>
                  <th className="px-1.5 py-1   font-normal">
                    Emp ID
                  </th>
                  <th className="px-1.5 py-1   font-normal">
                    Name
                  </th>
                  <th className="px-1.5 py-1   font-normal">
                    Job Title
                  </th>
                  <th className="px-1.5 py-1   font-normal">
                    Department
                  </th>
                  <th className="px-1.5 py-1   font-normal">
                    Division
                  </th>
                  <th className="px-1.5 py-1   font-normal">
                    Status
                  </th>
                  <th className="px-1.5 py-1   font-normal">
                    Nationality
                  </th>
                  <th className="px-1.5 py-1   font-normal">
                    Join Date
                  </th>
                  <th className="px-1.5 py-1   font-normal">
                    Basic Pay
                  </th>
                  <th className="px-1.5 py-1   font-normal">
                    Allowances
                  </th>
                  <th className="px-1.5 py-1   font-normal">
                    Increments
                  </th>
                  <th className="px-1.5 py-1   font-normal">
                    Nr Hrs
                  </th>
                  <th className="px-1.5 py-1   font-normal">
                    Ot Hrs
                  </th>
                  <th className="px-1.5 py-1   font-normal">
                    Ots Hrs
                  </th>
                  <th className="px-1.5 py-1   font-normal">
                    Abs Days
                  </th>
                  <th className="px-1.5 py-1   font-normal">
                    Total Wage
                  </th>

                  {Open && (
                    <>
                      <th className="px-1.5 py-1   font-normal">
                        Oth Additions
                      </th>
                      <th className="px-1.5 py-1   font-normal">
                        Gross Pay
                      </th>
                      <th className="px-1.5 py-1   font-normal">
                        Deductions
                      </th>
                      <th className="px-1.5 py-1   font-normal">
                        Net Pay
                      </th>
                      <th className="px-1.5 py-1   font-normal">
                        Loans & Adv
                      </th>
                    </>
                  )}

                  <th className="px-1.5 py-1   font-normal text-center">
                    Actions
                  </th>
                </tr>
              </thead>

              <tbody>
                {payrollData?.map((d, i) => (
                  <tr key={i} className="hover:bg-gray-50">
                    <td className="px-1.5 py-1 border">{i + 1}</td>
                    <td className="px-1.5 py-1 border">{d.EMP_ID}</td>
                    <td className="px-1.5 py-1 border">{d.NAME}</td>
                    <td className="px-1.5 py-1 border">{d.JOB_TITLE}</td>
                    <td className="px-1.5 py-1 border">{d.DEPARTMENT}</td>
                    <td className="px-1.5 py-1 border">{d.BRANCH}</td>
                    <td className="px-1.5 py-1 border">{d.STATUS}</td>
                    <td className="px-1.5 py-1 border">{d.NATIONALITY}</td>
                    <td className="px-1.5 py-1 border">
                      {d.JOIN_DATE
                        ? new Date(d.JOIN_DATE).toLocaleDateString("en-GB")
                        : ""}
                    </td>
                    <td className="px-1.5 py-1 border">{d.BASIC_PAY}</td>
                    <td className="px-1.5 py-1 border">{d.ALLOWANCES}</td>
                    <td className="px-1.5 py-1 border">{d.INCREMENTS}</td>
                    <td className="px-1.5 py-1 border">{d.NR_HRS}</td>
                    <td className="px-1.5 py-1 border">{d.OT_HRS}</td>
                    <td className="px-1.5 py-1 border">{d.OTS_HRS}</td>
                    <td className="px-1.5 py-1 border">{d.ABS_DAYS}</td>
                    <td className="px-1.5 py-1 border">{d.TOTAL_WAGE}</td>

                    {Open && (
                      <>
                        <td className="px-1.5 py-1 border">
                          {d.OTH_ADDITIONS}
                        </td>
                        <td className="px-1.5 py-1 border">{d.GROSS_PAY}</td>
                        <td className="px-1.5 py-1 border">{d.DEDUCTIONS}</td>
                        <td className="px-1.5 py-1 border">{d.NET_PAY}</td>
                        <td className="px-1.5 py-1 border">
                          {d.LOANS_AND_ADV}
                        </td>
                      </>
                    )}

                    <td className="px-1.5 py-1 border text-center space-x-2">
                      <button
                        className="bg-purple-500 text-white px-1 py-1 rounded-md text-xs hover:bg-purple-700 flex items-center gap-1"
                        // onClick={() => paySlipPopup(d)}
                        // onClick={() => setShowPayslip(true)}
                        onClick={() => callPaySlipAPI(d.EMP_ID)}
                      >
                        <FaFileInvoiceDollar className="text-sm" />
                        Payslip
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        ) : null}
        <SnackbarNotification
          open={snackbar.open}
          severity={snackbar.severity}
          message={snackbar.message}
          onClose={handleClose}
        />
      </div>
      {showPayslip && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative">
            {/* Close Button */}
            <button
              onClick={() => setShowPayslip(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl"
            >
              &times;
            </button>

            {/* Modal Content */}
            <h2 className="text-lg font-semibold mb-4">Payslip</h2>
            <div className="text-sm space-y-2">
              <p>
                <strong>Name:</strong> {payrollData.name}
              </p>
              <p>
                <strong>Net Pay:</strong> {payrollData.netPay}
              </p>
              <p>
                <strong>Total Wage:</strong> {payrollData.totalWage}
              </p>

              <button onClick={callPaySlipAPI}>Generate Payslip</button>
              {/* Add more payslip fields as needed */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MainPayroll;
